import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '@/features/account-management/account.navigator';
import { ModalContainerView } from '@/features/account-management/components/ModalContainerView';
import { DownloadAccountTransactionReport } from '@/features/account-management/screens/download-transaction-report/DownloadAccountTransactionReport';
import { DownloadCardAccountTransactionReport } from '@/features/account-management/screens/download-transaction-report/DownloadCardAccountTransactionReport';
import {
  DownloadTransactionReportStackParamList,
  DownloadTransactionReportStackRoutes
} from '@/features/account-management/screens/download-transaction-report/type';
import { SelectAccountScreen } from '@/features/card-account/screens/create-card-account/SelectAccount.screen';
import { SelectCardAccountScreen } from '@/features/card-account/screens/create-card-account/SelectCardAccount.screen';
import { CreateCardAccountStackParamList, CreateCardAccountStackRoutes } from '@/features/card-account/screens/create-card-account/type';
import { Dimensions } from 'react-native';

const DownloadTransactionReportStack = createNativeStackNavigator<DownloadTransactionReportStackParamList>();
const CreateCardAccountStack = createNativeStackNavigator<CreateCardAccountStackParamList>();

export const DownloadTransactionReportNavigator: React.FC<
  AccountManagementStackScreenProps<AccountManagementStackRoutes.DownloadTransactionReport>
> = ({ route, navigation }) => {
  const { walletId, creditLineId, onSelect, onChangeView, borderRadiusFlag } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  return (
    <ModalContainerView
      dimensions={dimensions}
      overflow={!layout.isMobile ? 'visible' : undefined}
      marginTop={
        (!layout.isMobile &&
          (route.params?.screen == DownloadTransactionReportStackRoutes.DownloadAccountTransactionReport ||
            route.params?.screen == DownloadTransactionReportStackRoutes.DownloadCardAccountTransactionReport)) ||
        ((route.params?.screen == CreateCardAccountStackRoutes.SelectAccount ||
          route.params?.screen == CreateCardAccountStackRoutes.SelectCardAccount) &&
          navigation.getState()?.index &&
          navigation.getState()?.routes[1]?.state &&
          navigation.getState()?.index != navigation.getState()?.routes[1]?.state?.index)
          ? -180
          : undefined
      }>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <DownloadTransactionReportStack.Navigator
          initialRouteName={DownloadTransactionReportStackRoutes.DownloadAccountTransactionReport}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <DownloadTransactionReportStack.Screen
            name={DownloadTransactionReportStackRoutes.DownloadAccountTransactionReport}
            component={DownloadAccountTransactionReport}
            initialParams={{ onLayout, walletId }}
            options={{ headerShown: false }}
          />
          <DownloadTransactionReportStack.Screen
            name={DownloadTransactionReportStackRoutes.DownloadCardAccountTransactionReport}
            component={DownloadCardAccountTransactionReport}
            initialParams={{ onLayout, creditLineId }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.SelectAccount}
            component={SelectAccountScreen}
            initialParams={{ onLayout, onSelect, onChangeView, borderRadiusFlag }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.SelectCardAccount}
            component={SelectCardAccountScreen}
            initialParams={{ onLayout, onSelect, onChangeView, borderRadiusFlag }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </DownloadTransactionReportStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
